import localeSlice from "../actions/locale";
import General from "../actions/general";
import permission from "../actions/permissions";

export const rootReducer = {
  Locale: localeSlice,
  General,
  permission,
};
